/**
 * Contact emails for the website.
 * Change these to update all mailto links and displayed addresses site-wide.
 */
export const CONTACT_EMAIL = 'tqstrats@gmail.com';
/** Email for careers / applications (can be same as CONTACT_EMAIL) */
export const CAREERS_EMAIL = 'tqstrats@gmail.com';

